import { ImmomioButtonComponent } from '@immomio/ui/button';
import {
  Component,
  OnInit,
  inject,
  input,
  computed,
  ChangeDetectionStrategy
} from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

import { CustomQuestion } from '@ui/shared/model';
import { TranslatePipe } from '@ngx-translate/core';
import { ModalFooterComponent } from '../../modal/modal-footer/modal-footer.component';
import { CustomQuestionFormComponent } from '../custom-question-form/custom-question-form.component';
import { ModalContentComponent } from '../../modal/modal-content/modal-content.component';
import { ModalComponent } from '../../modal/modal.component';

@Component({
  selector: 'app-custom-question-preview-modal',
  templateUrl: './custom-question-preview-modal.component.html',
  styleUrls: ['./custom-question-preview-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ImmomioButtonComponent,
    ModalComponent,
    ModalContentComponent,
    CustomQuestionFormComponent,
    FormsModule,
    ReactiveFormsModule,
    ModalFooterComponent,
    TranslatePipe
  ]
})
export class CustomQuestionPreviewModalComponent implements OnInit {
  private ngbActiveModal = inject(NgbActiveModal);

  public questionControl = new FormControl();
  public customQuestion = input<CustomQuestion>(undefined);
  public global = input<boolean>(undefined);
  public isGlobal = computed(
    () => this.global() ?? this.customQuestion().global
  );

  public ngOnInit() {
    if (this.customQuestion()) {
      this.questionControl.patchValue(this.customQuestion());
    }
  }

  public dismiss() {
    this.ngbActiveModal.dismiss();
  }
}
